export function ToAuthenticationDTO(values) {
    return {
        email: values.email,
        password: values.password,
    };
}
